export default __webpack_public_path__ + "static/media/about_02.98a5eb20.svg";